export default __webpack_public_path__ + "static/media/3177.9e275ae5.svg";